// Load global configuration

require('./globals')

import './assets/scss/_global.scss'

//SCSS overrides
import './assets/scss/overrides/awesome-notifications.scss'
import './assets/scss/overrides/vue-select.scss'
import './assets/scss/overrides/vue-date.scss'
import './assets/scss/overrides/vue-multiselect.scss'
import './assets/scss/overrides/v-tooltip.scss'
import './assets/scss/overrides/vue2-editor.scss'
import './assets/scss/overrides/vue-checkbox-radio.scss'

// vuejs-dialog
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

import { merge, orderBy, includes, indexOf, findIndex, intersection, remove, range } from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueMoment from 'vue-moment'
import momentDurationFormatSetup from 'moment-duration-format'
import VTooltip from 'v-tooltip'
import fullCalendar from 'fullcalendar'
import Tabs from 'vue-tabs-component'
import Toasted from 'vue-toasted'
import ProgressBar from 'vue-progressbar'
import AsyncComputed from 'vue-async-computed'
import Vuelidate from 'vuelidate'
import ToggleButton from 'vue-js-toggle-button'
import CheckboxRadio from 'vue-checkbox-radio'
import VuejsDialog from "vuejs-dialog"
import Notifications from 'vue-notification'
import pagination from "vuejs-uib-pagination"
import VueAnalytics from 'vue-analytics'
import Clipboard from 'v-clipboard'
import VueAWN from "vue-awesome-notifications"
import VueMultianalytics from 'vue-multianalytics'
import { VueEditor } from "vue2-editor"

import App from './App.vue'

// Setting up routes, store

import { routes } from './routes/routes'
import { store } from './store/store'

// Import global mixins and auth

import Mixins from './mixins'

// Directives and filters

import { clickOutsideDirective, focusDirective } from './directives/directives'
import { ellipsisFilter } from './filters/filters'

import VueIntercom from 'vue-intercom';
import VueI18n from 'vue-i18n'
import messages from './i18n/i18n'

// Router

const router = new VueRouter({
    routes,
    mode: 'history',
    saveScrollPosition: true
});

Vue.router = router;

// Fire dependencies

Vue.use(VueRouter)
Vue.use(VueMoment)
Vue.use(Tabs)
Vue.use(VTooltip)
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(AsyncComputed)
Vue.use(ProgressBar, {
    color: '#f16c64',
    thickness: '5px'
})
Vue.use(Toasted, {
    fitToScreen: true,
    fullWidth: false,
    position: 'top-center',
    className: 'alert',
    duration: 7000,
})
Vue.use(Mixins)
Vue.use(ToggleButton)
Vue.use(CheckboxRadio)
Vue.use(VuejsDialog, {
    html: true,
    okText: 'Yes',
    cancelText: 'No',
    animation: 'zoom',
    backdropClose: true,
})
Vue.use(Notifications)
Vue.use(pagination)
Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_ID,
  router
})
Vue.use(VueIntercom, { appId: 'zetpu2p7' });
Vue.use(Clipboard)
Vue.use(VueI18n)
Vue.use(VueAWN, {
    position: 'top-right',
    duration: 10000,
})
require("vue-awesome-notifications/dist/styles/style.css") //VueAWN

// let gaConfig = {
//   appName: 'Test', // Mandatory
//   appVersion: '0.1', // Mandatory
//   trackingId: 'YOUR_UA', // Mandatory
//   debug: true, // Whether or not display console logs debugs (optional)
// }

// vue multianalytics
let mixpanelConfig = {
  token: process.env.MIXPANEL_TOKEN,
}


Vue.use(VueMultianalytics, {
    modules: {
        // ga: gaConfig,
        mixpanel: mixpanelConfig
    },
    routing: {
        vueRouter: router, //  Pass the router instance to automatically sync with router (optional)
        preferredProperty: 'name', // By default 'path' and related with vueRouter (optional)
        // ignoredViews: ['homepage'], // Views that will not be tracked
        // ignoredModules: ['ga'] // Modules that will not send route change events. The event sent will be this.$ma.trackView({viewName: 'homepage'}, ['ga'])
    }

})


//testing i18n
// const = messages

const i18n = new VueI18n({
    locale: 'fr', // set locale
    messages // set locale messages
})


// Directives and filters

Vue.directive('force-focus', focusDirective);
Vue.directive('click-outside', clickOutsideDirective);
Vue.filter('ellipsis', ellipsisFilter);

// Load async/sync requests configuration

require('./transport')

// eventBus that allows us to do $emit between diferent components
export const eventHub = new Vue();


new Vue({
    // i18n,
    el: '#app',
    router,
    store,
    data() {
      return {
      }
    },
    mounted() {
        if(process.env.SHOW_INTERCOM == true){
            this.$intercom.boot();
        }
    },
    watch: {
      email(email) {
        this.$intercom.update({email});
      },
    },
    components: {
        App
    },
    render: function(createElement) {
        return createElement(App);
    },
});



// WEBPACK FOOTER //
// ./src/main.js